export var CustomerChatMessageOption;
(function (CustomerChatMessageOption) {
    CustomerChatMessageOption["PRIVATE"] = "PRIVATE";
})(CustomerChatMessageOption || (CustomerChatMessageOption = {}));
